<template>
  <div class="wrap">
    <Nav :title="$t('loan')" fixed safeAreaInsetTop placeholder />
    <div class="content">
      <div class="apply_tips">
        <div class="top_tips">{{ $t('goods.maximumLoanAmount') }}</div>
        <div class="amount">{{ userInfo.credit_rank && userInfo.credit_rank.min_money || 0 }}-{{ userInfo.credit_rank &&
          userInfo.credit_rank.max_money || 0 }}{{ verConfig.moneyType }}
        </div>
        <div class="loan_money">
          <div class="label">{{ $t('loanAmount') }}</div>
          <van-field v-model="money" type="Number" label-width="0" :placeholder="$t('请输入贷款金额')" />
        </div>
      </div>
      <div class="expect">
        <div class="expect_item" :class="activeNum == item.expect ? 'active' : ''" v-for="(item, index) in expectList"
          :key="index" @click="itemClick(item)">
          {{ item.expect }}
        </div>
      </div>
      <div class="loan" v-if="money && activeNum">
        <div class="loan_item">
          <div class="label">{{ $t('applicationAmount') }}:</div>
          <div class="value">{{ money }}</div>
        </div>
        <div class="loan_item">
          <div class="label">{{ $t('installmentAmount') }}:</div>
          <div class="value">{{ getMoney() }}</div>
        </div>
        <div class="loan_item">
          <div class="label">{{ $t('interestRate') }}:</div>
          <div class="value">{{ rate.rate }}%</div>
        </div>
        <div class="loan_item">
          <div class="label">{{ $t('terms') }}:</div>
          <div class="value">{{ activeNum }}</div>
        </div>
      </div>
      <div v-if="money && activeNum" class="btn" @click="loadApply">{{ $t('user.Button.Two') }}</div>
    </div>
  </div>
</template>
<script>
import Nav from "@/components/Navbar";
import { mapGetters } from "vuex";
import { Field } from "vant"
import { LOAN_APPLY } from "@/api"
export default {
  components: {
    Nav,
    [Field.name]: Field
  },
  data() {
    return {
      money: '',
      activeNum: '',
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    expectList() {
      const obj = this.userInfo.credit_rank || {};
      let expects = obj.expect || {}
      let arr = Object.entries(expects);
      const resultArray = arr.length && arr.map(([key, value]) => ({
        expect: Number(key),
        rate: value
      }));
      return resultArray || []
    },
    rate() {
      const item = this.expectList.length && this.expectList.find(val => val.expect == this.activeNum)
      return item || {}
    }
  },
  created() {
    this.$store.dispatch('getUserInfo')
  },
  methods: {
    itemClick(item) {
      if (this.activeNum == item.expect) {
        return this.activeNum = "";
      }
      this.activeNum = item.expect;
      if (!this.money) {
        this.money = this.userInfo.credit_rank.min_money;
      }
      this.getMoney();
    },
    getMoney() {
      let num = this.money * (1 + Number(this.rate.rate || 0) / 12 / 100 * this.activeNum) / this.activeNum
      return Number(num.toFixed(2));
    },
    async loadApply() {
      try {
        const res = await LOAN_APPLY({
          money: this.money,
          expect: this.activeNum
        })
        this.$toast(res.msg)
        setTimeout(()=>{
          this.$router.back();
        },1000)
      } catch (error) {
        this.$toast(error.msg)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background: var(--bgImg) no-repeat;
  background-size: cover;

  .content {
    padding: calc(20rem / 16) calc(10rem / 16);

    .apply_tips {
      background: linear-gradient(90deg,#692c82,#270e31);
      color: var(--white);
      border-radius: calc(10rem / 16);
      padding: calc(20rem / 16) calc(20rem / 16);

      .top_tips {
        font-size: calc(14rem / 16);
        font-weight: 400;
      }

      .amount {
        margin-top: calc(10rem / 16);
        display: block;
        font-size: calc(20rem / 16);
        font-weight: 700;
      }

      .loan_money {
        display: flex;
        align-items: center;
        margin-top: calc(20rem / 16);

        .label {
          font-size: calc(16rem / 16);
          color: var(--white);
          white-space: nowrap;
          margin-right: calc(10rem / 16);
        }

        /deep/ .van-cell {
          background-color: #fff;
          border-radius: calc(4rem / 16);
          padding: calc(6rem / 16) calc(10rem / 16);
        }
      }
    }

    .expect {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-around;
      gap: calc(16rem / 16);
      margin-top: calc(20rem / 16);

      &_item {
        flex: 1;
        padding: calc(10rem / 16);
        border-radius: calc(4rem / 16);
        border: 2px solid var(--white);
        color: var(--white);
        text-align: center;
        font-size: calc(16rem / 16);
      }

      .active {
        background: var(--btnColor);
        color: var(--white);
        border: none;
        padding: calc(12rem / 16);
      }
    }

    .loan {
      background-color: var(--white);
      border-radius: calc(4rem / 16);
      margin-top: calc(20rem / 16);

      &_item {
        padding: calc(5rem / 16) calc(10rem / 16);
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: calc(14rem / 16);
        border-bottom: 1px dashed silver;

        .value {
          color: #606266;
          line-height: calc(30rem / 16);
          padding: 0 calc(15rem / 16);
        }
      }

      &_item:last-child {
        border-bottom-width: 0;
      }
    }

    .btn {
      height: calc(45rem / 16);
      border-radius: calc(4rem / 16);
      background: var(--btnColor);
      color: var(--white);
      font-size: calc(16rem / 16);
      text-align: center;
      line-height: calc(45rem / 16);
      margin-top: calc(60rem / 16);
    }
  }
}
</style>